const USER_PERIMSSION = "user_permission";

const PermissionService = {
    getPermission() {
        var userPermission = JSON.parse(localStorage.getItem(USER_PERIMSSION));
        if (userPermission) {
            return userPermission;
        }
    },

    savePermission(userPermissionResponse) {
        localStorage.setItem(USER_PERIMSSION, JSON.stringify(userPermissionResponse));
    },

    removePermission() {
        localStorage.removeItem(USER_PERIMSSION);
    },

    checkPermission(permission) {
        if ( this.getPermission().includes(permission) ) {
            return true;
        }
        else return false;
    },

    getPermissionDict(permissionName) {
        var PermissionObj = {
            "AuditLogs": "Permissions.Administration.AuditLogs",
            "SimpleLogs": "Permissions.Administration.SimpleLogs",
            "GlobalSearch": "Permissions.Administration.GlobalSearch",
            "Export": "Permissions.Administration.Export",

            "Roles": "Permissions.Roles",
            "ViewRoles": "Permissions.Roles.View",
            "CreateRoles": "Permissions.Roles.Create",
            "EditRoles": "Permissions.Roles.Edit",
            "DeleteRoles": "Permissions.Roles.Delete",

            "Users": "Permissions.Users",
            "ViewUsers": "Permissions.Users.View",
            "CreateUsers": "Permissions.Users.Create",
            "EditUsers": "Permissions.Users.Edit",
            "DeleteUsers": "Permissions.Users.Delete",
            "EditUsersPermission": "Permissions.Users.ChangePermissions",

            "Research": "Permissions.Research",

            "Experiment": "Permissions.Research.Experiments",
            "ViewExperiment": "Permissions.Research.Experiments.View",
            "CreateExperiment": "Permissions.Research.Experiments.Create",
            "EditExperiment": "Permissions.Research.Experiments.Edit",
            "DeleteExperiment": "Permissions.Research.Experiments.Delete",

            "ImportSampling": "Permissions.Research.Experiments.ImportSampling",
            "ExperimentSuperadmin": "Permissions.Research.Experiments.SuperAdmin",

            "Progenies": "Permissions.Research.Progenies",
            "ViewProgenies": "Permissions.Research.Progenies.View",
            "CreateProgenies": "Permissions.Research.Progenies.Create",
            "EditProgenies": "Permissions.Research.Progenies.Edit",
            "DeleteProgenies": "Permissions.Research.Progenies.Delete",

            "Palms": "Permissions.Research.Palms",
            "ViewPalms": "Permissions.Research.Palms.View",
            "CreatePalms": "Permissions.Research.Palms.Create",
            "EditPalms": "Permissions.Research.Palms.Edit",
            "DeletePalms": "Permissions.Research.Palms.Delete",

            "Breeding": "Permissions.Breeding" ,
            "BreedingSuperAdmin": "Permissions.Breeding.SuperAdmin" ,
            "Imports": "Permissions.Breeding.Imports" ,
            "Imports": "Permissions.Breeding.Imports.Trial" ,
            "Imports": "Permissions.Breeding.Imports.RawData" ,
            "Inputs": "Permissions.Breeding.Inputs" ,

            "Programs": "Permissions.Breeding.Programs" ,
            "ViewPrograms": "Permissions.Breeding.Programs.View" ,
            "CreatePrograms": "Permissions.Breeding.Programs.Create" ,
            "EditPrograms": "Permissions.Breeding.Programs.Edit" ,
            "DeletePrograms": "Permissions.Breeding.Programs.Delete" ,

            "Progenies": "Permissions.Breeding.Progenies" ,
            "ViewProgenies": "Permissions.Breeding.Progenies.View" ,
            "CreateProgenies": "Permissions.Breeding.Progenies.Create" ,
            "EditProgenies": "Permissions.Breeding.Progenies.Edit" ,
            "DeleteProgenies": "Permissions.Breeding.Progenies.Delete" ,

            "Agencies": "Permissions.Breeding.Agencies" ,
            "ViewAgencies": "Permissions.Breeding.Agencies.View" ,
            "CreateAgencies": "Permissions.Breeding.Agencies.Create" ,
            "EditAgencies": "Permissions.Breeding.Agencies.Edit" ,
            "DeleteAgencies": "Permissions.Breeding.Agencies.Delete" ,

            "Germplasms": "Permissions.Breeding.Germplasms" ,
            "ViewGermplasms": "Permissions.Breeding.Germplasms.View" ,
            "CreateGermplasms": "Permissions.Breeding.Germplasms.Create" ,
            "EditGermplasms": "Permissions.Breeding.Germplasms.Edit" ,
            "DeleteGermplasms": "Permissions.Breeding.Germplasms.Delete" ,

            "Trials": "Permissions.Breeding.Trials" ,
            "ViewTrials": "Permissions.Breeding.Trials.View" ,
            "CreateTrials": "Permissions.Breeding.Trials.Create" ,
            "EditTrials": "Permissions.Breeding.Trials.Edit" ,
            "DeleteTrials": "Permissions.Breeding.Trials.Delete" ,

            "RawData": "Permissions.Breeding.RawData" ,
            "RawDataBunch": "Permissions.Breeding.RawData.Bunch" ,
            "RawDataCarotene": "Permissions.Breeding.RawData.Carotene" ,
            "RawDataFattyAcid": "Permissions.Breeding.RawData.FattyAcid" ,
            "RawDataVegetative": "Permissions.Breeding.RawData.Vegetative" ,
            "RawDataVitamin": "Permissions.Breeding.RawData.Vitamin" ,
            "RawDataYield": "Permissions.Breeding.RawData.Yield" ,

            "DerivedData": "Permissions.Breeding.DerivedData" ,
            "DerivedDataBunch": "Permissions.Breeding.DerivedData.Bunch" ,
            "DerivedDataVegetative": "Permissions.Breeding.DerivedData.Vegetative" ,
            "DerivedDataYield": "Permissions.Breeding.DerivedData.Yield" ,

            "Analytics": "Permissions.Breeding.Analytics" ,

            "AdvancedSearch": "Permissions.Breeding.AdvancedSearch",

            "Configurations": "Permissions.Breeding.Configurations" ,
            "AnalyticsConfigurations": "Permissions.Breeding.Configurations.Analytics" ,
            "TypesConfigurations": "Permissions.Breeding.Configurations.Types" ,
            "OthersConfigurations": "Permissions.Breeding.Configurations.Others" ,
            "ProgeniesConfigurations": "Permissions.Configuration.Progenies" ,
            "InventoriesConfigurations": "Permissions.Configuration.Inventories" ,
            "ExperimentsConfigurations": "Permissions.Configuration.Experiments" ,
            "TrialsConfigurations": "Permissions.Configuration.Trials" ,

            "Exports": "Permissions.Breeding.Exports" 
        };

        return PermissionObj[permissionName];
        
    }
};

export {
    PermissionService
};


// WEBPACK FOOTER //
// ./src/services/permission.service.js